import React, { FC, useEffect, useState } from 'react';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import SpecialBtn from './SpecialBtn';

//
function ConnectWallet(props: any) {

    function connectWalletHandler() {
        var walletBtn = document.getElementsByClassName("wallet-adapter-button");

        if (walletBtn && walletBtn.length > 0) {
            (walletBtn[0] as HTMLElement).click();
        }
    }

    return (
        <Box className={props.className} style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <img src={props.ornament ? props.ornament : "/mint/Ornament_Dark_Rust.png"} style={{ maxWidth: "300px", width: "100%" }} />

            {props.header &&
                <Box sx={{ marginTop: "20px", fontSize: "26px", color: props.textColor ? props.textColor : '#cb7d34', fontWeight: 700, textAlign: "center", lineHeight: 1.3 }}>
                    <Box>{props.header}</Box>
                </Box>}

            {props.body &&
                <Box sx={{ color: props.textColor ? props.textColor : '#cb7d34', textAlign: "center", marginBottom: "30px", fontSize: "18px", fontWeight: 700 }}>
                    <Box>{props.body}</Box>
                </Box>}

            <SpecialBtn variant="white" label="Connect Wallet" textColor={props.btnTextColor ? props.btnTextColor : "#331f0d"} inProg={false} onClick={connectWalletHandler} />
        </Box>
    );
}

// Default style!
const ConnectWalletStyled = styled(ConnectWallet)({
});

// Export
export default ConnectWalletStyled;